export default __webpack_public_path__ + "static/media/Wallpaper-1.13e22f45.jpg";